$(function () {
	const $module = $('.module-accesrapide');
	if (!$module.length) return;

	const $wrap = $module.find('.mar-wrap');

	// Placeholder pour garder l’espace quand .mar-wrap passe en fixed
	const $ph = $('<div class="mar-wrap-ph" aria-hidden="true"></div>').hide();
	$ph.insertAfter($wrap);

	let lastY = window.pageYOffset || 0;
	let anchorTop = 0; // position Y d’origine du module
	let ticking = false;

	function syncPlaceholder() {
		// hauteur pour éviter le "jump" quand on fixe
		$ph.height($wrap.outerHeight(true));
	}

	function computeAnchor() {
		// position du conteneur dans la page (où le module doit redevenir "normal")
		anchorTop = $module.offset().top;
		syncPlaceholder();
	}

	function setFixed(on) {
		if (on) {
			if (!$module.hasClass('fixed')) {
				$module.addClass('fixed');
				syncPlaceholder();
				$ph.show();
			}
		} else {
			if ($module.hasClass('fixed')) {
				$module.removeClass('fixed');
				$ph.hide().height(0);
			}
		}
	}

	function onScroll() {
		if (ticking) return;
		ticking = true;
		requestAnimationFrame(() => {
			const y = window.pageYOffset || document.documentElement.scrollTop;
			const goingDown = y > lastY;

			// Ajoute .fixed seulement quand on descend et qu'on a dépassé la position d'origine
			if (goingDown && y >= anchorTop) {
				setFixed(true);
			}
			// Retire .fixed quand on remonte et qu'on repasse au-dessus de la position d'origine
			else if (!goingDown && y < anchorTop) {
				setFixed(false);
			}

			lastY = y;
			ticking = false;
		});
	}

	// Init + listeners
	computeAnchor();
	$(window).on('scroll', onScroll);
	$(window).on('resize', () => {
		// petit debounce implicite via RAF
		requestAnimationFrame(() => {
			const wasFixed = $module.hasClass('fixed');
			setFixed(false); // retire pour mesurer correctement
			computeAnchor();
			if (wasFixed && window.pageYOffset >= anchorTop) setFixed(true);
		});
	});

	// Recalcule après le load (images, webfonts…)
	$(window).on('load', () => {
		computeAnchor();
		// Applique l'état correct si la page est déjà scrollee
		if (window.pageYOffset >= anchorTop) setFixed(true);
	});
});

/*
SUIVI AUTO
$(function () {
	if ($(".jssticky").length) {
		// === Références ===
		const $carousel = $('.mar-carousel');            // <ul class="mar-carousel">…</ul>
		const $links = $('.mar-carousel .mar-link');     // chaque lien dans le carrousel

		// === Indexer les liens (utile pour slickGoTo) ===
		$links.each(function(i){
			this.dataset.idx = i; // ex: data-idx="0"
		});

		// === Init Slick ===
		$carousel.slick({
			dots: false,
			arrows: false,
			infinite: false,
			autoplay: false,
			adaptiveHeight: true,
			centerMode: true,      // mettre true si tu veux centrer l’actif
			variableWidth: true,
			touchThreshold: 30,
			
			focusOnSelect: true
		});

		// === Scrollspy ===
		const sections = [];
		$links.each(function(){
			const id = this.getAttribute('href').replace('#','');
			const section = document.getElementById(id);
			if (section) sections.push({ id, section, link: this, idx: +this.dataset.idx });
		});

		function setActive(idx) {
			$('.mar-link').removeClass('active');
			const link = $links.get(idx);
			if (link) {
				link.classList.add('active');
				// Faire défiler le carrousel jusqu'au slide correspondant
				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('slickGoTo', idx);
				}
			}
		}

		const spyObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;
				const found = sections.find(s => s.section === entry.target);
				if (found) setActive(found.idx);
			});
		}, {
			// déclenche quand la section passe au milieu de l'écran
			rootMargin: '-50% 0px -50% 0px',
			threshold: 0
		});
		sections.forEach(s => spyObserver.observe(s.section));

		// === Clique sur un lien : garder le menu en vue immédiatement ===
		$(document).on('click', '.mar-link', function(){
			const idx = +this.dataset.idx || 0;
			if ($carousel.hasClass('slick-initialized')) {
				$carousel.slick('slickGoTo', idx);
			}
			// le scroll vers l’ancre se fait ensuite, et le scrollspy remettra l’active proprement
		});

		// (Optionnel) au chargement, synchroniser l'état si on arrive avec un hash
		if (location.hash) {
			const idxFromHash = sections.findIndex(s => '#'+s.id === location.hash);
			if (idxFromHash >= 0) setActive(idxFromHash);
		}
	}
});
*/


$(function () {
	if ($(".jssticky").length) {
		// Gestion sticky
		const target = document.querySelector('.jssticky');
		

		// Gestion scrollspy
		const links = document.querySelectorAll('.mar-link');
		const sections = [];

		links.forEach(link => {
			const id = link.getAttribute('href').replace('#', '');
			const section = document.getElementById(id);
			if (section) {
				sections.push({ id, section, link });
			}
		});

		const spyObserver = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				const found = sections.find(s => s.section === entry.target);
				if (entry.isIntersecting) {
					$('.mar-link').removeClass('active');
					if (found) found.link.classList.add('active');
				}
			});
		}, {
			rootMargin: '-50% 0px -50% 0px', // déclenche quand la section est au milieu
			threshold: 0
		});

		sections.forEach(s => spyObserver.observe(s.section));
	}
});

$(document).ready(function() {
	$('.mar-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		autoplay: false,
		autoplaySpeed: 3000,
		mobileFirst: false,
		adaptiveHeight: true,
		centerMode: false,
		variableWidth: true,
		touchThreshold: 30
	});
});
